// see https://css-tricks.com/snippets/javascript/javascript-keycodes/ for codes

const keyCodes = {
  tab: 9,
  backspace: 8,
  enter: 13,
  delete: 46,
  space: 32,
};

const keyTypes = {
  number: e => e.key && !isNaN(e.key),
};

const checkCode = (e, keyName) => {
  const keyCode = e.charCode || e.keyCode;
  if (keyCode === keyCodes[keyName]) return true;
  if (keyTypes[keyName]) return keyTypes[keyName](e);
  return false;
};

const isKey = (e, keyNames) => keyNames.some(keyName => checkCode(e, keyName));

export default isKey;
